import { useAppDispatch } from "../../../app/hooks";
import { useNavigate } from "react-router-dom";
import { classroomSlice } from "../../../redux/classroom/classroomSlice";
import { useSelector } from "react-redux";
import { selectUser } from "../../../redux/user/userSlice";
import { hasPermission, PermissionId } from "../../../app/permissions";
import AddIcon from "@mui/icons-material/Add";
import PrizaAvatarGrid, { PrizaAvatarGridItem } from "../../../features/base/grid/PrizaAvatarGrid";
import { assertThumbnailUrl, LoadState } from "../../../redux/common";
import { retrieveSchoolDpto, schoolDptosSlice, selectSchoolDptos } from "../../../redux/school/schoolDptosSlice";
import { useEffect } from "react";
import { isTokenReady } from "../../../features/user/UserAvatar";
import { dptoSlice } from "../../../redux/dpto/dptoSlice";
import { routeDpto, routeDptoNew } from "../../../routes/dpto";

interface ContentListProps {
    schoolId: string;
}

const DptoList = ({ schoolId }: ContentListProps) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const user = useSelector(selectUser);
    const dptos = useSelector(selectSchoolDptos);

    useEffect(() => {
        if (dptos.schoolId && dptos.schoolId != schoolId) {
            dispatch(schoolDptosSlice.actions.clean());
        }
        if (dptos.state.state == LoadState.NotStarted && isTokenReady(user))
            dispatch(retrieveSchoolDpto({ schoolId }));
    }, [dptos, schoolId, user]);


    const list = dptos.list || [];

    const mapped: PrizaAvatarGridItem[] = list.map((item) => {
        return {
            image: assertThumbnailUrl(item.url),
            title: item.name,
            subtitle: "Departamento",
            click: () => {
                dispatch(dptoSlice.actions.select(item));
                navigate(routeDpto(schoolId, item.id));
            }
        };
    });

    const buttons = hasPermission(user.priza.info, PermissionId.SCHOOL_ADMIN, schoolId) ? [
        {
            label: <AddIcon />,
            click: () => {
                dispatch(classroomSlice.actions.clean());
                navigate(routeDptoNew(schoolId));
            }
        }
    ] : undefined;

    return <PrizaAvatarGrid list={mapped}
        toolbar={{
            label: "Departamentos",
            buttons: buttons
        }}
        state={dptos.state}
        retry={() => { dispatch(schoolDptosSlice.actions.clean()); }}
        messages={{
            empty: "Nenhum departamento associado a esta escola.",
            error: "Erro ao carregar departamentos."
        }}
    />;

};

export default DptoList;